import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon, FileTextIcon, RefreshCwIcon, SendIcon } from 'lucide-react';
interface PrescriptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'refill' | 'transfer';
}
export function PrescriptionModal({
  isOpen,
  onClose,
  type
}: PrescriptionModalProps) {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      setSubmitted(false);
      onClose();
    }, 3000);
  };
  return <AnimatePresence data-id="element-179" data-mp="3tts5phxfz9qq">
      {isOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm z-[100]" data-id="element-180" data-mp="3tua70syyoe5i" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed inset-0 m-auto w-full max-w-lg h-fit bg-white rounded-3xl shadow-2xl z-[101] overflow-hidden" data-id="element-181" data-mp="382kjqmjr3f9t">
            <div className="p-6 border-b border-slate-100 flex justify-between items-center bg-slate-50/50" data-id="element-182" data-mp="3qz2g5h9jo3ce">
              <div className="flex items-center gap-3" data-id="element-183" data-mp="3h38u979xqxhy">
                <div className="w-10 h-10 bg-clinical-blue/10 rounded-xl flex items-center justify-center text-clinical-blue" data-id="element-184" data-mp="3h1o1nn76lomq">
                  {type === 'refill' ? <RefreshCwIcon className="w-5 h-5" data-id="element-185" data-mp="25oc2vqqa3w7f" /> : <FileTextIcon className="w-5 h-5" data-id="element-186" data-mp="21mqmvwig71t0" />}
                </div>
                <div data-id="element-187" data-mp="233xdv3ve1u4l">
                  <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight" data-id="element-188" data-mp="234p8abd91lta">
                    {type === 'refill' ? 'Refill Prescription' : 'Transfer Prescription'}
                  </h2>
                  <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-189" data-mp="1t7ua5tkw1nfj">
                    Secure Request Form
                  </p>
                </div>
              </div>
              <button onClick={onClose} className="p-2 hover:bg-slate-200 rounded-full transition-colors" data-id="element-190" data-mp="1kbbkqrbv8hnp">
                <XIcon className="w-5 h-5 text-slate-400" data-id="element-191" data-mp="1ag1ko9512kck" />
              </button>
            </div>

            <div className="p-8" data-id="element-192" data-mp="1ff4knf65i0do">
              {submitted ? <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="text-center py-12" data-id="element-193" data-mp="11ek6wxf3eur1">
                  <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-194" data-mp="ht1vh7l7cyml">
                    <SendIcon className="w-8 h-8" data-id="element-195" data-mp="vtunnlo17hmj" />
                  </div>
                  <h3 className="text-2xl font-black text-slate-900 mb-2 uppercase tracking-tight" data-id="element-196" data-mp="qs5bu3szizxe">
                    Request Sent!
                  </h3>
                  <p className="text-slate-500" data-id="element-197" data-mp="15o4kbfk0b232">
                    Our pharmacy team will process your request and contact you
                    shortly.
                  </p>
                </motion.div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-198" data-mp="1agnx4aavdt6t">
                  <div className="grid grid-cols-2 gap-4" data-id="element-199" data-mp="1ajjvu0ujklwb">
                    <div className="space-y-2" data-id="element-200" data-mp="1ohqggfahcpe1">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-201" data-mp="1jhvpkbqpfzsz">
                        First Name
                      </label>
                      <input required type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-202" data-mp="23hw0xqeu6dl0" />
                    </div>
                    <div className="space-y-2" data-id="element-203" data-mp="1klmcqaa806na">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-204" data-mp="1kmxg48zr7cdv">
                        Last Name
                      </label>
                      <input required type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-205" data-mp="1tkrahedyjvye" />
                    </div>
                  </div>

                  <div className="space-y-2" data-id="element-206" data-mp="ycfo4qlrisl6">
                    <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-207" data-mp="yc5vswd8w9cb">
                      Date of Birth
                    </label>
                    <input required type="date" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-208" data-mp="ome1m3925i8d" />
                  </div>

                  {type === 'refill' ? <div className="space-y-2" data-id="element-209" data-mp="5o1pq9qrhu93">
                      <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-210" data-mp="5ota0oews5k2">
                        Rx Number(s)
                      </label>
                      <input required placeholder="e.g. 1234567, 8901234" type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-211" data-mp="202kpw5ntzlny" />
                    </div> : <>
                      <div className="space-y-2" data-id="element-212" data-mp="3fixieiyljemo">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-213" data-mp="3kjbt68rl12oe">
                          Current Pharmacy Name
                        </label>
                        <input required type="text" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-214" data-mp="h3wlhe6of56f" />
                      </div>
                      <div className="space-y-2" data-id="element-215" data-mp="2nsjb55l390jz">
                        <label className="text-[10px] font-bold text-slate-400 uppercase tracking-widest" data-id="element-216" data-mp="2rvxua54bpx1n">
                          Current Pharmacy Phone
                        </label>
                        <input required type="tel" className="w-full px-4 py-3 bg-slate-50 border border-slate-200 rounded-xl focus:ring-2 focus:ring-clinical-blue/20 focus:border-clinical-blue outline-none transition-all" data-id="element-217" data-mp="2fd2dwk6l1ec8" />
                      </div>
                    </>}

                  <div className="pt-4" data-id="element-218" data-mp="1wmks6zk63j0d">
                    <button type="submit" className="w-full bg-clinical-blue text-white font-black py-4 rounded-xl hover:bg-blue-700 transition-all uppercase tracking-widest text-xs shadow-lg shadow-clinical-blue/20" data-id="element-219" data-mp="1wnndmryq0t8w">
                      Submit Request
                    </button>
                  </div>
                </form>}
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}